import styled from '@emotion/styled';
import Button from '__components/Button';
import { GenericWizardSection } from '__components/GenericWizard';
import { DeletedOption } from '../types';
import { TFunction } from 'react-i18next';

const oneSectionHeight = 110;
const oneSectionMargin = 18;
const extraSectionRow = 101;

type Section = {
  label: string;
  options: Array<{
    label: string;
    value: string;
    key?: string;
    image?: React.ReactElement;
  }>;
};

export const getMaxHeight = (sections: Array<Section>) =>
  sections.reduce(
    (prev, section) =>
      section.options.length
        ? prev +
          oneSectionHeight +
          Math.floor((section.options.length - 1) / 4) * extraSectionRow
        : prev,
    1 + Math.max(sections.length - 1, 0) * oneSectionMargin
  );

export const ChangeBtn = styled(Button)`
  margin: 19px 0 0;
  padding: 0;
  height: 12px;
`;

export const ResizableSection = styled(GenericWizardSection)`
  margin-top: 0;
  padding-top: 17px;
`;

export const addDeleted = (
  value: DeletedOption | null | undefined,
  t: TFunction
) =>
  value?.deleted
    ? {
        ...value,
        label: `${value?.label} [${t('Deleted')}]`,
      }
    : value;

export const addDeletedToList = (
  value: Array<DeletedOption> | null | undefined,
  t: TFunction
) => {
  if (!Array.isArray(value)) {
    return value;
  }

  return value.map((o) =>
    o?.deleted
      ? {
          ...o,
          label: `${o?.label} [${t('Deleted')}]`,
          error: true,
        }
      : o
  );
};
